
import React, {
    useEffect
}
from "react";

import HomeIntelligenceCard
from "./HomeIntelligenceCard";

import "./HomeDataOverview.css";

import background
from "../../../../../images/omniscanbackgroundoffice.jpg";


//========================================================
// Home Data Overview
//
// Full-screen Executive Intelligence panel.
//
// Slides up from the bottom of the viewport.
//
// Displays six reusable intelligence cards.
//
// Each card independently manages its chart selector.
//========================================================

export default function HomeDataOverview({
    open = false,
    subjects = [],
    onClose
})
{

    //========================================================
    // Keyboard And Scroll Handling
    //========================================================

    useEffect(
        function()
        {

            if(!open)
            {
                return;
            }


            //------------------------------------------------
            // Escape Key
            //------------------------------------------------

            const handleKeyDown =
                function(event)
                {

                    if(event.key === "Escape")
                    {
                        onClose();
                    }

                };


            //------------------------------------------------
            // Lock Background Scrolling
            //------------------------------------------------

            const previousOverflow =
                document.body.style.overflow;

            document.body.style.overflow =
                "hidden";

            window.addEventListener(
                "keydown",
                handleKeyDown
            );


            //------------------------------------------------
            // Cleanup
            //------------------------------------------------

            return function()
            {

                document.body.style.overflow =
                    previousOverflow;

                window.removeEventListener(
                    "keydown",
                    handleKeyDown
                );

            };

        },
        [open, onClose]
    );


    //========================================================
    // Card Display Configuration
    //
    // These are presentation defaults only.
    //
    // Subject identity, colour and available chart types
    // continue to come from the parent scroller.
    //========================================================

    const CARD_DEFAULTS =
    {
        utilisation: {
            description: "Workplace occupancy and usage",
            defaultChart: "Total"
        },

        space: {
            description: "Area, allocation and efficiency",
            defaultChart: "Stack"
        },

        energy: {
            description: "Consumption and performance",
            defaultChart: "Trend"
        },

        financials: {
            description: "Cost and financial performance",
            defaultChart: "Top Ten"
        },

        carbon: {
            description: "Emissions and sustainability",
            defaultChart: "Total"
        },

        incidents: {
            description: "Risk, safety and incident analysis",
            defaultChart: "Spider"
        }
    };


    //========================================================
    // Prepare Subjects For Cards
    //
    // Normalise chart type labels from the scroller.
    //========================================================

    const intelligenceSubjects =
        subjects.map(
            function(subject)
            {

                const defaults =
                    CARD_DEFAULTS[subject.id] || {};

                const chartTypes =
                    (subject.chartTypes || []).map(
                        function(type)
                        {

                            if(type.toLowerCase() === "topten")
                            {
                                return "Top Ten";
                            }

                            return (
                                type.charAt(0).toUpperCase()
                                +
                                type.slice(1)
                            );

                        }
                    );

                const preferredChart =
                    defaults.defaultChart;

                const defaultChart =
                    chartTypes.includes(preferredChart)
                        ?
                        preferredChart
                        :
                        chartTypes[0] || "Total";

                return {
                    ...subject,

                    description:
                        subject.description ||
                        defaults.description ||
                        "",

                    chartTypes:
                        chartTypes,

                    defaultChart:
                        defaultChart
                };

            }
        );


    //========================================================
    // Render
    //========================================================

    return (

        <div
            className={
                "home-data-overview"
                +
                (
                    open
                        ?
                        " open"
                        :
                        ""
                )
            }

            aria-hidden={!open}
        >

            {/* ==========================================
                BACKDROP
            ========================================== */}

            <div
                className="home-data-overview-backdrop"

                onClick={onClose}
            />


            {/* ==========================================
                SLIDING PANEL
            ========================================== */}

            <div
                className="home-data-overview-panel"

                style={{
                    "--home-overview-background":
                        `url("${background}")`
                }}

                role={open ? "dialog" : undefined}
                aria-modal={open ? "true" : undefined}
                aria-label="Executive Intelligence"
            >

                {/* ======================================
                    HEADER
                ====================================== */}

                <div className="home-data-overview-header">

                    <div className="home-data-overview-heading">

                        <div className="home-data-overview-eyebrow">

                            OMNISCAN INTELLIGENCE

                        </div>

                        <div className="home-data-overview-title">

                            Executive Intelligence

                        </div>

                        <div className="home-data-overview-subtitle">

                            Portfolio performance at a glance

                        </div>

                    </div>


                    {/* ==================================
                        CLOSE
                    ================================== */}

                    <button
                        type="button"
                        className="home-data-overview-close"

                        onClick={onClose}

                        aria-label="Close Executive Intelligence"
                    >

                        ×

                    </button>

                </div>


                {/* ======================================
                    CONTENT
                ====================================== */}

                <div className="home-data-overview-content">

                    {/* ==================================
                        INTELLIGENCE CARD GRID
                    ================================== */}

                    <div className="home-intelligence-grid">

                        {
                            intelligenceSubjects.map(
                                function(subject, index)
                                {

                                    return (

                                        <HomeIntelligenceCard
                                            key={subject.id}

                                            subject={subject}

                                            delay={index * 90}
                                        />

                                    );

                                }
                            )
                        }

                    </div>

                </div>


              

            </div>

        </div>

    );

}
